<template>
  <v-container>
    <h1>Produkter</h1>
    <AdminBreadcrumbs tail-text="Produkter" />

    <v-card class="orange lighten-5" elevation="3">
      <v-card-title class="white--text orange"> Produkter </v-card-title>

      <v-container>
        <v-row align="center" justify="center">
          <v-col cols="3" offset="0">
            <v-btn
              color="success"
              :to="{
                name: 'adminProductCreate',
                params: { vendorId: vendorId },
              }"
            >
              <v-icon left> mdi-folder-plus </v-icon>
              Lag nytt produkt
            </v-btn>
          </v-col>
          <v-col cols="3" offset="6">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Søk"
              single-line
              hide-details
            />
          </v-col>
        </v-row>
      </v-container>

      <v-data-table
        :headers="headers"
        :items="products"
        :search="search"
        sort-by="ordered_at"
        class="orange lighten-5"
      >
        <template v-slot:item.name="{ item }">
          <router-link
            :to="{
              name: 'adminProductDetail',
              params: {
                vendorId: vendor.id.toString(),
                productId: item.id.toString(),
              },
            }"
          >
            {{ item.name }}
          </router-link>
        </template>

        <template v-slot:item.price="{ item }">
          kr {{ item.price }},-
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import backend from "@/backend";
import AdminBreadcrumbs from "@/components/AdminBreadcrumbs";

export default {
  name: "AdminProducts",

  components: {
    AdminBreadcrumbs,
  },

  props: {
    vendorId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    vendor: {},
    products: [],
    search: "",
    headers: [
      {
        text: "Navn",
        value: "name",
      },
      {
        text: "Beskrivelse",
        value: "description",
      },
      {
        text: "Pris",
        value: "price",
      },
    ],
  }),

  async created() {
    this.vendor = await backend.get(`vendors/${this.vendorId}/`);

    const productsData = await backend.get("products/", {
      vendor: this.vendorId,
    });

    this.products = productsData;
  },
};
</script>
